export default __webpack_public_path__ + "static/media/Overview-of-Partnership.d3f3d1da.png";